<template>
  <div>
    <v-form
        ref="userAccountForm"
    >
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-select
              v-model="account.type"
              :items="accountTypes"
              item-text="text"
              item-value="type"
              label="Typ konta"
              disabled
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
              v-model="account.username"
              label="Login"
              disabled
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="account.email"
              label="E-Mail"
              disabled
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-slide-group
              multiple
              show-arrows
          >
            <v-slide-item
                v-for="(role, i) in account.roles"
                :key="i"
            >
              <v-btn
                  class="mx-2"
                  active-class="purple white--text"
                  small
                  depressed
                  rounded
              >
                {{ role }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
              v-model="landingLink"
              readonly
              ref="landingLink"
          >
            <template slot="append-outer">
              <v-btn @click="onLandingLinkCopyTriggered" title="Kopiuj do schowka.">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              v-model="recordsLink"
              readonly
              ref="recordsLink"
          >
            <template slot="append-outer">
              <v-btn @click="onRecordsLinkCopyTriggered" title="Kopiuj do schowka.">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import api from '@/services/api';

export default {
  data() {
    return {
      loading: false,
      accountTypes: [
        { type: 'guest', text: 'Gość' },
        { type: 'managed', text: 'Zarządzane przez partnera' },
        { type: 'registered', text: 'W pełni zarejestrowane' },
      ],
      account: {
        type: '',
        username: '',
        email: '',
        roles: [],
      },
      landingLink: '',
      recordsLink: '',
      landingBaseUrl: process.env.VUE_APP_LANDING_URL,
    }
  },
  created() {
    this.loadDetails();
    this.prepareLinks();
  },
  methods: {
    loadDetails() {
      if (this.loading) {
        return;
      }

      const identity = this.$store.state.user.identity;
      this.account.roles = Array.from(identity.roles);

      api.get(`/api/users/${identity.userId}`)
          .then((response) => {
            const data = response.data;

            this.account.type = data.type;
            this.account.username = data.username;
            this.account.email = data.email;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać danych konta.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onLandingLinkCopyTriggered() {
      const textToCopy = this.$refs.landingLink.$el.querySelector('input');
      textToCopy.select();
      document.execCommand('copy');
    },
    onRecordsLinkCopyTriggered() {
      const textToCopy = this.$refs.recordsLink.$el.querySelector('input');
      textToCopy.select();
      document.execCommand('copy');
    },
    prepareLinks() {
      let link = this.landingBaseUrl;

      if (localStorage.getItem('code')) {
        link += '?s=' + localStorage.getItem('code');
      }

      this.landingLink = link;
      this.recordsLink = link.replace('mamodpad', 'gielda').replace('?', '/wycen-odpad?');
    }
  }
}
</script>